import { Select } from 'antd';
import { CollapsibleSection } from '@/shared/ui/CollapsibleSection';
import type { AdminStudyFilterOptions } from './useAdminStudyFilterOptions';
import styles from './AdminStudyFilterRail.module.css';

interface AdminScopeSectionProps {
  selectedSites: string[];
  onSitesChange: (v: string[]) => void;
  siteOptions: AdminStudyFilterOptions['siteOptions'];
}

export default function AdminScopeSection({
  selectedSites,
  onSitesChange,
  siteOptions,
}: AdminScopeSectionProps) {
  return (
    <CollapsibleSection
      title="Scope"
      count={selectedSites.length}
      onClear={() => onSitesChange([])}
    >
      <div className={styles.filterGroup}>
        <label htmlFor="admin-site" className={styles.filterLabel}>
          Site / Organization
        </label>
        <Select
          id="admin-site"
          mode="multiple"
          allowClear
          placeholder="All sites"
          value={selectedSites}
          onChange={onSitesChange}
          options={siteOptions}
          className={styles.fullWidth}
        />
      </div>
    </CollapsibleSection>
  );
}
